import { createModel } from '@rematch/core';
import { Dispatch } from '../../store';
import { EncounterRx } from '../../models/encounter-rx';
import { storeByIMPSId } from '../../utils/converter';
import { getAppointmentEncounterRxes } from '../../apis/encounter-rx';

export interface State {
    byId: Dictionary<EncounterRx>;
    loading: Dictionary<boolean>;
}

export const encounterRxes = createModel<State>({
    state: {
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: Undefinable<MixType<EncounterRx>>,
            loadingKey?: string
        ): State => {
            const hasData = Array.isArray(data) ? data.length > 0 : data;
            if (hasData || loadingKey) {
                return {
                    ...state,
                    byId: {
                        ...state.byId,
                        ...storeByIMPSId(data)
                    },
                    ...loadingKey && {
                        loading: {
                            ...state.loading,
                            [loadingKey]: false
                        }
                    }
                };
            } else {
                return state;
            }
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: dispatch => ({
        async getAppointmentEncounterRxesAsync(appointmentId: number) {
            const {
                compositeDrugs
                // @ts-ignore
            } = dispatch as Dispatch;
            this.loading('getAppointmentEncounterRxesAsync', true);
            try {
                const data = await getAppointmentEncounterRxes(appointmentId);
                this.update(data, 'getAppointmentEncounterRxesAsync');

                // Collect related data
                if (data) {
                    compositeDrugs.getCompositeDrugsAsync(data.map(x => x.medId));
                }
            } catch (e) {
                window.console.log(e);
                this.loading('getAppointmentEncounterRxesAsync', false);
            }
        }
    })
});
